import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export const OverlayComponent = ({ content, changeLayout, contentProps }) => {
  useEffect(() => {
    if (!content) {
      changeLayout({ overlay: { mode: 'hidden' } });
    }
  }, [changeLayout, content]);

  const Content = content;

  if (!Content) {
    return null;
  }

  return (
    <div
      className="overlay-component"
      style={{
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Content {...contentProps} />
    </div>
  );
};

OverlayComponent.propTypes = {
  content: PropTypes.elementType,
  changeLayout: PropTypes.func.isRequired,
  contentProps: PropTypes.shape({}),
};

OverlayComponent.defaultProps = {
  content: null,
  contentProps: {},
};
